import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetConfigurationDictionariesQuery,
  useLazyGetConfigurationSettingsQuery,
} from '../../store/dictionaries/service';
import { BankRoutes } from '../../routes';

import cn from './integration-logs.module.css';

const IntegrationLogs = (): React.JSX.Element => {
  const navigate = useNavigate();
  const match = useMatch(BankRoutes.INTEGRATIONS_LOGS);

  const { activePermissions, riskScoreRanges, overdraftEnabled } =
    useAppSelector((state) => state.configurationDictionaries);

  const [getDictionaries] = useLazyGetConfigurationDictionariesQuery();
  const [getConfigurationSettings] = useLazyGetConfigurationSettingsQuery();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.SECTION_PSP) &&
      activePermissions.includes(PermissionEnum.PSP_INTEGRATION_LOGS_LIST)
    ) {
      if (!riskScoreRanges) {
        getDictionaries();
      }

      if (match) {
        navigate(BankRoutes.INTEGRATIONS_LOGS_LIST);
      }

      if (overdraftEnabled === undefined || overdraftEnabled === null) {
        getConfigurationSettings();
      }
    }
  }, [match, activePermissions, riskScoreRanges, overdraftEnabled]);

  useEffect(() => {
    let title = 'Integration Logs';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.integrationLogsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_PSP) ||
      !activePermissions.includes(PermissionEnum.PSP_INTEGRATION_LOGS_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.integrationLogs}>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default IntegrationLogs;
